// extracted by mini-css-extract-plugin
export var deleteIcon = "_r8-5";
export var deleteOption = "_r8-3";
export var divider = "_r8-2";
export var downloadIcon = "_r8-4";
export var drawer = "_r8-0";
export var drawerFooter = "_r8-6";
export var drawerOpen = "_r8-1";
export var highlighted = "_r8-7";
export var lighterHighlight = "_r8-8";